const NAME = "SPECIAL_PROCESS_DEFINITION_PARAMETERS";

export default NAME;
